module.exports = __webpack_public_path__ + "img/browse-vehicles-background-mazda.1e008b3c.png";